export class Guid {
      static getGuidFromUrl(): string | Error {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)

            if (!urlParams.has('guid')) {
                  throw new Error('Please add guid')
            }
            const guid = urlParams.get('guid')

            return guid;
      }
}